import styled, { createGlobalStyle } from 'styled-components';
import { DndProvider } from 'react-dnd';
import { ResponsiveWidth } from 'components/Css';

export const GlobalStyle = createGlobalStyle`
  body, html {
    background-color: var(--color-neutral-light-lighter) !important;
  }
`;

export const Provider = styled(DndProvider)`
  .mobileViewer & {
    zoom: 0.5;
    width: 400px;
  }
`;

export const BarRadius = styled.div`
  @media (max-width: ${ResponsiveWidth}px) {
    height: var(--borderRadiusBase);
    border-radius: var(--borderRadiusBase) var(--borderRadiusBase) 0px 0px;
    margin-top: calc(-1 * var(--borderRadiusBase));
    background-color: var(--colorBgBase);
  }
`;
